<div class="container container-margin">
  @if (!isForAddToCatalogue) {
    <div class="row">
      <h2>{{ translationService.getAdvancedSearchText() }}</h2>
    </div>
  } @else {
    <div class="row">
      <h2>{{ translationService.getAddToCatalogueText() }}</h2>
    </div>
  }

  <div class="container">
    <form>
      <app-product-filter (filterOutput)="filter($event)"></app-product-filter>

      <h2>{{ recordCount }} {{ translationService.getResultsText() }}</h2>

      <app-product-list
        [products]="popularProducts"
        [displayedColumns]="displayedColumns"
        (addToCatalogue)="addToCatalogue.emit($event)"
        [shouldShowCopiedIcons]="shouldShowCopiedIcons"
      ></app-product-list>

      <mat-paginator
        (page)="changePage($event)"
        [length]="recordCount"
        showFirstLastButtons
        pageSize="10"
      ></mat-paginator>
    </form>
  </div>
</div>
